module.exports = __webpack_public_path__ + "static/media/SR.320b3b4f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/SR.svg
// module id = 364
// module chunks = 0